
<template>
  <!-- 服务订单 serviceOrders -->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="id"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
    >

      <template slot="opt_number" slot-scope="{row}">
        <span>{{ row.goodsNums }}{{row.businessType == 1?'件':'次'}}</span>
      </template>
      <template slot="opt_img" slot-scope="{row}">
        <img style="height: 44px;width:auto" :src="row.imgUrl" alt="">
      </template>

      <template slot="opt_status" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="activityColor[row.orderStatus]"></span>
          <span>{{ row.orderStatusDesc }}</span>
        </div>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
const activityType = [
  { value: 1, label: '活动 ' },
  { value: 2, label: '团购' }
];
export default {
  name: 'localServiceOrders',
  mixins: [fetchSelect],
  data () {
    return {
      activityColor: [
        'info-bg',
        'info-bg',
        'info-bg',
        'success-bg',
        'danger-bg'
      ],
      searchList: [
        { props: ['orderId'], placeholder: '订单号', options: [], inputType: 'input' },
        {
          props: ['businessType'],
          placeholder: '类型',
          options: [
            {label: '代取快递', value: 1},
            {label: '代扔垃圾', value: 2}
          ],
          inputType: 'select'
        },
        {
          props: ['orderStatus'],
          placeholder: '状态',
          options: [
            {label: '未开始', value: 1},
            {label: '进行中', value: 2},
            {label: '已完成', value: 3},
            {label: '已退款', value: 4}
          ],
          inputType: 'select'
        },
        { props: ['mobile'], placeholder: '账号', options: [], inputType: 'input' }
      ],
      tableOptList: [],
      rowOptList: [
        { text: '详情', handle: (row) => this.toDetail(row.orderId), permi: ['community:housekeepOrder:detail'] }
      ],
      columns: [
        { title: '昵称', dataIndex: 'nickName', align: '', width: '' },
        { title: '账号', dataIndex: 'mobile', align: '', width: '' },
        { title: '服务类型', dataIndex: 'businessTypeDesc', align: '', width: '' },
        { title: '商家名称', dataIndex: 'shopName', align: '', width: '' },
        { title: '数量', dataIndex: 'goodsNums', align: '', width: '', scopedSlots: { customRender: 'number' } },
        { title: '总金额', dataIndex: 'totalFee', align: '', width: '', customCell: (row) => ({ domProps: { innerHTML: '￥' + row.totalFee} })},
        { title: '实付', dataIndex: 'totalFee', align: '', width: '', customCell: (row) => ({ domProps: { innerHTML: '￥' + row.payFee} })},
        { title: '下单时间', dataIndex: 'createTime', align: '', width: '' },
        { title: '状态', dataIndex: 'orderStatus', align: '', width: '', scopedSlots: { customRender: 'status' } },
        { title: '操作', dataIndex: 'action', align: '', width: '', scopedSlots: { customRender: 'action' } }
      ],
      dataSource: [],
      searchParams: {
        orderId: undefined,
        businessType: undefined,
        orderStatus: undefined,
        mobile: undefined
      },
      listApi: {
        url: '/housekeep/order/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      }
    };
  },
  created () {
  },
  methods: {
    // 详情
    toDetail (id) {
      this.$router.push({
        name: 'localServiceOrdersDetail',
        query: { id: id, ...this.breadParam(this) }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
